export default "__VITE_ASSET__D$XqjlU3__"